export default function BusinessSolutionsArticleData() {
  return {
    title: "Top 3 Solutions for Businesses",
    items: [
      {
        image : "/product-landing/busi/buy-sell.png",
        mobileImage: "/product-landing/busi/buy-sell-small.png",
        title: "Buy Sell",
        subtitle: "Do you have a plan in place today?",
        paragraph: "A formal agreement established by and between business owners, family members or key employees helps keep your business going due to death of an Owner. Life Insurance, coupled with a Buy-Sell Agreement, can help reduce the financial strain on the remaining owners.",
        callToAction: [
          {
            buttonTitle: "SEE SOLUTION",
            anchor: "buysell",
          }
        ],
      },
      {
        image : "/product-landing/busi/key-person.png",
        mobileImage: "/product-landing/busi/key-person-small.png",
        title: "Key Person",
        subtitle: "Do you have a plan in place to protect the integrity, cash flow and ongoing success of your business from the loss of a key employee due to death?",
        paragraph: "Key Person insurance helps the business overcome additional expenses associated with recruiting and training a replacement.",
        callToAction: [
          {
            buttonTitle: "SEE SOLUTION",
            anchor: "keyperson",
          }
        ],
      },
      { 
        image : "/product-landing/busi/small-business.png",
        mobileImage: "/product-landing/busi/small-business-small.png",
        title: "Life Insurance for Small Business",
        subtitle: "Have you applied for or need a Small Business Loan to help your company achieve its goals or provide the financial cushion it needs to take the next steps?",
        paragraph: "Typically, to qualify as loan collateral, a life insurance policy must be in place for the same amount and length of time as the loan.",
        callToAction: [
          {
            buttonTitle: "SEE SOLUTION",
            anchor: "smallbusiness",
          }
        ],
      },
    ]
  };
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/BusinessSolutions/BusinessSolutionsArticleData.js